// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"012bb322","498":"153781b8","703":"a7065199","787":"6a717f43"}[chunkId] + ".chunk.js";
};